module.exports = __webpack_public_path__ + "./fonts/2846c106de77654ee4cbbf0d8eb7fff6.ttf";